import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-not-seleted-room',
    templateUrl: './not-seleted-room.component.html',
    styleUrls: ['./not-seleted-room.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotSeletedRoomComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
